var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#33CBCC;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.4,0.6H106.6C47.2,3.4,0,52.4,0,112.4v58.7h512v-58.7C512,52.4,464.8,3.4,405.4,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,400.4c0,61.9,50.1,112,112,112h288c61.9,0,112-50.1,112-112v-58.7H0V400.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 171.1,
    className: "st0",
    width: 512,
    height: 170.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.6,343.1h112.5v27.6H65V141.3h143.3V169H97.6v71.5h97l-3.5,26.9H97.6V343.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445.1,141.3v229.3H409L308.1,222l-4.6-6.7c-0.5-0.9-1.9-3.2-4.4-6.7s-4.6-6.8-6.4-9.9 c-1.8-3.1-3.4-6.1-4.8-9.2v181.2h-31.1V141.3h34.3l103.7,151.8c0.9,1.4,2.9,4.3,6,8.7c3.1,4.4,5.7,8.4,7.8,12 c2.1,3.7,3.9,7.1,5.3,10.4v-183L445.1,141.3L445.1,141.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/En.60f390cba5e8977d9e64189f28a4f0ec.svg";
export { ForwardRef as ReactComponent };